import React from 'react'
import { components } from 'react-select'
import type { SelectAsyncProps } from '@ztechapps/webui.input'
import { SelectAsync } from '@ztechapps/webui.input'
import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { gql } from '@apollo/client'
import { InventoryBySerialNumberWidget } from '../Widget/InventoryBySerialNumberWidget'

export const inventoryBySerialNumberSelectFragment = gql`
  fragment inventoryBySerialNumberSelectFragment on InventoryBySerialNumber {
    _id
    code
    status
    product {
      _id
      code
      serialNumberType
      requiredSerialNumber
    }
    batchCode
  }
`

export const queries = buildGraphqlQuery('InventoryBySerialNumber', inventoryBySerialNumberSelectFragment)

const Option = ({ data, ...rest }: any) => {
  //always set the isSelected to false so it wont highlight
  return (
    <components.Option {...{ ...rest, data, isSelected: false }}>
      <InventoryBySerialNumberWidget status={data.status} code={data.code} />
    </components.Option>
  )
}

const dataLoadOptions = ({ filter }) => ({
  query: queries.allNoMetaConfig.query,
  filter: ({ input }) => ({
    $or: [{ code: { $regex: input, $options: 'i' } }, { batchCode: { $regex: input, $options: 'i' } }],
    ...filter,
  }),
  resultFieldName: 'allInventoryBySerialNumber',
  options: () => ({
    sort: { createdAt: -1 as const },
    fetchPolicy: 'network-only',
  }),
})

export const InventoryBySerialNumberSelect = ({
  filter,
  placeholder = 'Type serial number or batch code',
  ...rest
}: SelectAsyncProps) => {
  return (
    <SelectAsync
      {...{
        ...rest,
        components: { Option },
        placeholder,
        labelKey: 'code',
        noOptionsMessage: () => 'Cannot find any serial numbers from the inventory.',
        dataLoadOptions: dataLoadOptions({ filter }),
      }}
    />
  )
}
